import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '@/components/MainLayout'
import home from "@/views/page1"
import news_information from "@/views/page2"
import product_introduction from "@/views/page3"
import about_us from "@/views/page4"
import page5 from "@/views/page5"
import contact_us from "@/views/page6"
import login from "@/views/Login"
import loading from "@/views/loading"

// 页面SEO配置
const routeMeta = {
  home: {
    title: '武汉飞凌越智能科技有限公司官网 - 机器人控制系统、智能制造解决方案',
    metaTags: [
      { name: 'description', content: '武汉飞凌越智能科技有限公司专注于智能控制与智能制造技术研发、生产，为用户提供自动化应用解决方案。涉及机器人控制系统、机器视觉、移动机器人等领域。' },
      { name: 'keywords', content: '武汉飞凌越,飞凌越智能,机器人控制系统,智能制造,自动化解决方案' },
      { property: 'og:title', content: '武汉飞凌越智能科技有限公司官网' },
      { property: 'og:description', content: '专注于智能控制与智能制造技术研发、生产，为用户提供自动化应用解决方案' }
    ]
  },
  news_information: {
    title: '新闻资讯 - 武汉飞凌越智能科技有限公司',
    metaTags: [
      { name: 'description', content: '武汉飞凌越智能科技有限公司最新新闻资讯，了解公司最新动态、技术进展和行业资讯。' },
      { name: 'keywords', content: '飞凌越新闻,机器人资讯,智能制造新闻,自动化技术资讯' }
    ]
  },
  product_introduction: {
    title: '产品介绍 - 武汉飞凌越智能科技有限公司',
    metaTags: [
      { name: 'description', content: '武汉飞凌越智能科技有限公司产品介绍：机器人控制系统、机器视觉应用、移动机器人等自动化解决方案。' },
      { name: 'keywords', content: '机器人控制系统,机器视觉,移动机器人,工业机器人,协作机器人' }
    ]
  },
  about_us: {
    title: '关于我们 - 武汉飞凌越智能科技有限公司',
    metaTags: [
      { name: 'description', content: '武汉飞凌越智能科技有限公司介绍：以机器人核心技术为依托，专注于智能控制与智能制造技术研发、生产的高新技术企业。' },
      { name: 'keywords', content: '关于飞凌越,飞凌越智能,公司介绍,技术研发' }
    ]
  },
  contact_us: {
    title: '联系我们 - 武汉飞凌越智能科技有限公司',
    metaTags: [
      { name: 'description', content: '联系武汉飞凌越智能科技有限公司，了解机器人控制系统、智能制造解决方案的详细信息。' },
      { name: 'keywords', content: '联系飞凌越,飞凌越智能,联系方式,业务咨询' }
    ]
  }
}
const routes = [
  {
  	path: '/',
  	name: '/',
  	// redirect:"/login",
	redirect:"/main",
  },
  {
  	path: '/loading',
  	name: 'loading',
  	component:loading
  },
  {
  	path: '/login',
  	name: 'login',
  	component:login
  },
  {
    path: '/main',
    name: 'MainLayout',
    component: MainLayout,
	redirect:"/main/home",
	children:[
		{
			path:'home',
			name:'home',
			component:home,
			meta: routeMeta.home
		},
		{
			path:'news_information',
			name:'news_information',
			component:news_information,
			meta: routeMeta.news_information
		},
		{
			path:'product_introduction',
			name:'product_introduction',
			component:product_introduction,
			meta: routeMeta.product_introduction
		},
		{
			path:'about_us',
			name:'about_us',
			component:about_us,
			meta: routeMeta.about_us
		},
		{
			path:'page5',
			name:'page5',
			component:page5,
		},
		{
			path:'contact_us',
			name:'contact_us',
			component:contact_us,
			meta: routeMeta.contact_us
		},
	]
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
